module.exports = __webpack_public_path__ + "img/bg-01.bda34928.jpg";